/**
 * Der Knopf „Lesen“ eines Mail-Treffers holt die ganze Mail von der Lese-Route (server/mail-lesen-route.ts, shared/mail-lesen.ts).
 * Gesendet wird nur die Kennung, mit dem Pflichtkopf der eigenen Seite (wie lib/karte-anfrage.ts). Kein Modell, kein Verlauf:
 * die Mail bleibt in diesem Browser.
 * Antwort: `{ ok: true, mail }` oder ein fester Fehlercode; Netz oder unlesbare Antwort = „nicht-bereit“.
 */
import { MAIL_LESEN_FEHLER, MAIL_LESEN_KOPF_WERT, MAIL_LESEN_PFAD, type MailLesenFehlerCode } from "../../shared/mail-lesen.js";

export type MailLesenErgebnis = { ok: true; mail: Record<string, unknown> } | { ok: false; error: MailLesenFehlerCode };

export async function holeMail(id: string): Promise<MailLesenErgebnis> {
  try {
    const r = await fetch(MAIL_LESEN_PFAD, {
      method: "POST",
      credentials: "same-origin",
      cache: "no-store",
      headers: { "Content-Type": "application/json", "X-Vespera-Aktion": MAIL_LESEN_KOPF_WERT },
      body: JSON.stringify({ id }),
    });
    const j = (await r.json().catch(() => null)) as { ok?: unknown; error?: unknown; mail?: unknown } | null;
    if (j?.ok === true && r.ok && j.mail && typeof j.mail === "object" && !Array.isArray(j.mail)) {
      return { ok: true, mail: j.mail as Record<string, unknown> };
    }
    const code = j && (MAIL_LESEN_FEHLER as readonly string[]).includes(String(j.error)) ? (j.error as MailLesenFehlerCode) : "nicht-bereit";
    return { ok: false, error: code };
  } catch {
    return { ok: false, error: "nicht-bereit" };
  }
}
